import API from "./../API/index";

export default {
  login: (context, payload) => {
    return API.login(payload);
  },

  fetchStatistics: (context, payload) => {
    return API.fetchStatistics();
  },

  fetchTotalApplication: (contet, payload) => {
    return API.fetchTotalApplication();
  },

  fetchAppVersions: (context, payload) => {
    return API.fetchAppVersions(payload);
  },

  createAppVersion: (context, payload) => {
    return API.createAppVersion(payload);
  },

  fetchTotalAppVersion: (context, payload) => {
    return API.fetchTotalAppVersion();
  },

  fetchJobApplications: (context, payload) => {
    return API.fetchJobApplications(payload, context);
  },

  fetchJobApplication: (context, payload) => {
    return API.fetchJobApplication(payload);
  },

  fetchTotalJobApplicationByStatus: (context, payload) => {
    return API.fetchTotalJobApplicationByStatus(payload);
  },

  fetchTalents: (context, payload) => {
    return API.fetchTalents(payload, context);
  },

  fetchEmployees: (context, payload) => {
    return API.fetchEmployees(payload, context);
  },

  fetchEmployee: (context, payload) => {
    return API.fetchEmployee(payload);
  },

  fetchTotalEmployee: (context, payload) => {
    return API.fetchTotalEmployee(payload);
  },

  fetchEmployers: (context, payload) => {
    return API.fetchEmployers(payload, context);
  },

  fetchEmployer: (context, payload) => {
    return API.fetchEmployer(payload);
  },

  fetchPendingEmployer: (context, payload) => {
    return API.fetchPendingEmployer(payload);
  },

  fetchTotalEmployer: (context, payload) => {
    return API.fetchTotalEmployer(payload);
  },

  createPackage: (context, payload) => {
    return API.createPackage(payload);
  },

  updatePackage: (context, payload) => {
    return API.updatePackage(payload);
  },

  deletePackage: (context, payload) => {
    return API.deletePackage(payload);
  },

  fetchCreditPackage: (context, payload) => {
    return API.fetchCreditPackage(payload);
  },

  fetchCreditPackages: (context, payload) => {
    return API.fetchCreditPackages(payload);
  },

  fetchActiveCreditPackages: (context, payload) => {
    return API.fetchActiveCreditPackages(payload);
  },

  fetchCreditPackagesList: (context, payload) => {
    return API.fetchCreditPackagesList();
  },

  fetchTotalCreditPackage: (context, payload) => {
    return API.fetchTotalCreditPackage(payload);
  },

  fetchArticles: (context, payload) => {
    return API.fetchArticles(payload);
  },

  fetchArticle: (context, payload) => {
    return API.fetchArticle(payload);
  },

  createArticle: (context, payload) => {
    return API.createArticle(payload);
  },

  updateArticle: (context, payload) => {
    return API.updateArticle(payload);
  },

  deleteArticle: (context, payload) => {
    return API.deleteArticle(payload);
  },

  fetchTotalJobType: (context, payload) => {
    return API.fetchTotalJobType(payload, context);
  },

  fetchTotalArticles: (context, payload) => {
    return API.fetchTotalArticles(payload, context);
  },

  fetchTotalSpecialization: (context, payload) => {
    return API.fetchTotalSpecialization();
  },

  fetchTotalPositionLevel: (context, payload) => {
    return API.fetchTotalPositionLevel();
  },

  fetchTotalIndustry: (context, payload) => {
    return API.fetchTotalIndustry();
  },

  fetchTotalDressCode: (context, payload) => {
    return API.fetchTotalDressCode();
  },

  fetchTotalCompanySize: (context, payload) => {
    return API.fetchTotalCompanySize();
  },

  fetchTotalSpokenLanguage: (context, payload) => {
    return API.fetchTotalSpokenLanguage();
  },

  fetchTotalQualification: (context, payload) => {
    return API.fetchTotalQualification();
  },

  fetchSpecializations: (context, payload) => {
    return API.fetchSpecializations(payload);
  },

  fetchSpokenLanguages: (context, payload) => {
    return API.fetchSpokenLanguages(payload);
  },

  fetchPositionLevels: (context, payload) => {
    return API.fetchPositionLevels(payload);
  },

  createPositionLevel: (context, payload) => {
    return API.createPositionLevel(payload);
  },

  deletePositionLevel: (context, payload) => {
    return API.deletePositionLevel(payload);
  },

  fetchIndustries: (context, payload) => {
    return API.fetchIndustries(payload);
  },

  deleteIndustry: (context, payload) => {
    return API.deleteIndustry(payload);
  },

  fetchDressCodes: (context, payload) => {
    return API.fetchDressCodes(payload);
  },

  deleteDressCode: (context, payload) => {
    return API.deleteDressCode(payload);
  },

  fetchCompanySizes: (context, payload) => {
    return API.fetchCompanySizes(payload);
  },

  fetchJobTypes: (context, payload) => {
    return API.fetchJobTypes(payload);
  },

  fetchQualifications: (context, payload) => {
    return API.fetchQualifications(payload);
  },

  deleteQualification: (context, payload) => {
    return API.deleteQualification(payload);
  },

  deleteJobType: (context, payload) => {
    return API.deleteJobType(payload);
  },

  createSpecialization: (context, payload) => {
    return API.createSpecialization(payload);
  },

  createJobType: (context, payload) => {
    return API.createJobType(payload);
  },

  deleteSpecialization: (context, payload) => {
    return API.deleteSpecialization(payload);
  },

  createIndustry: (context, payload) => {
    return API.createIndustry(payload);
  },

  updateIndustry: (context, payload) => {
    return API.updateIndustry(payload);
  },

  updateDressCode: (context, payload) => {
    return API.updateDressCode(payload);
  },

  updateCompanySize: (context, payload) => {
    return API.updateCompanySize(payload);
  },

  updateSpokenLanguage: (context, payload) => {
    return API.updateSpokenLanguage(payload);
  },

  updateQualification: (context, payload) => {
    return API.updateQualification(payload);
  },

  updateJobType: (context, payload) => {
    return API.updateJobType(payload);
  },

  updateSpecialization: (context, payload) => {
    return API.updateSpecialization(payload);
  },

  updatePositionLevel: (context, payload) => {
    return API.updatePositionLevel(payload);
  },

  updatePackageStatus: (context, payload) => {
    return API.updatePackageStatus(payload);
  },

  createDressCode: (context, payload) => {
    return API.createDressCode(payload);
  },

  createCompanySize: (context, payload) => {
    return API.createCompanySize(payload);
  },

  deleteCompanySize: (context, payload) => {
    return API.deleteCompanySize(payload);
  },

  createSpokenLanguage: (context, payload) => {
    return API.createSpokenLanguage(payload);
  },

  deleteSpokenLanguage: (context, payload) => {
    return API.deleteSpokenLanguage(payload);
  },

  createQualification: (context, payload) => {
    return API.createQualification(payload);
  },

  fetchPushNotifications: (context, payload) => {
    return API.fetchPushNotifications(payload);
  },

  fetchTotalPushNotification: (context, payload) => {
    return API.fetchTotalPushNotification();
  },

  createPushNotification: (context, payload) => {
    return API.createPushNotification(payload);
  },

  fetchCreditPackageTransactions: (context, payload) => {
    return API.fetchCreditPackageTransactions(payload);
  },

  fetchTotalCreditPackageTransaction: (context, payload) => {
    return API.fetchTotalCreditPackageTransaction();
  },

  changePassword: (context, payload) => {
    return API.changePassword(payload);
  },

  fetchEmployersStaticContent: (context, payload) => {
    return API.fetchEmployersStaticContent();
  },

  fetchCandidatesStaticContent: (context, payload) => {
    return API.fetchCandidatesStaticContent();
  },

  fetchCountries: (context, payload) => {
    return API.fetchCountries();
  },

  fetchStates: (context, payload) => {
    return API.fetchStates(payload);
  },

  fetchDressCodesList: (context, payload) => {
    return API.fetchDressCodesList(payload);
  },

  fetchIndustriesList: (context, payload) => {
    return API.fetchIndustriesList();
  },

  fetchCompanySizesList: (context, payload) => {
    return API.fetchCompanySizesList();
  },

  fetchSpokenLanguagesList: (context, payload) => {
    return API.fetchSpokenLanguagesList();
  },

  fetchCandidatesTermsAndCondition: (context, payload) => {
    return API.fetchCandidatesTermsAndCondition();
  },

  fetchEmployersTermsAndCondition: (context, payload) => {
    return API.fetchEmployersTermsAndCondition();
  },

  updateCandidatesTermsAndCondition: (context, payload) => {
    return API.updateCandidatesTermsAndCondition(payload);
  },

  updateEmployersTermsAndCondition: (context, payload) => {
    return API.updateEmployersTermsAndCondition(payload);
  },

  fetchCandidatesPrivacyPolicy: (context, payload) => {
    return API.fetchCandidatesPrivacyPolicy();
  },

  fetchEmployersPrivacyPolicy: (context, payload) => {
    return API.fetchEmployersPrivacyPolicy();
  },

  updateCandidatesPrivacyPolicy: (context, payload) => {
    return API.updateCandidatesPrivacyPolicy(payload);
  },

  updateEmployersPrivacyPolicy: (context, payload) => {
    return API.updateEmployersPrivacyPolicy(payload);
  },

  fetchCandidatesContactUs: (context, payload) => {
    return API.fetchCandidatesContactUs();
  },

  fetchEmployersContactUs: (context, payload) => {
    return API.fetchEmployersContactUs();
  },

  fetchCandidatesAboutUs: (context, payload) => {
    return API.fetchCandidatesAboutUs();
  },

  fetchEmployersAboutUs: (context, payload) => {
    return API.fetchEmployersAboutUs();
  },

  uploadCandidatesAboutUsBanner: (context, payload) => {
    return API.uploadCandidatesAboutUsBanner(payload);
  },

  uploadEmployersAboutUsBanner: (context, payload) => {
    return API.uploadEmployersAboutUsBanner(payload);
  },

  updateCandidatesAboutUs: (context, payload) => {
    return API.updateCandidatesAboutUs(payload);
  },

  updateEmployersAboutUs: (context, payload) => {
    return API.updateEmployersAboutUs(payload);
  },

  updateCandidatesContactUs: (context, payload) => {
    return API.updateCandidatesContactUs(payload);
  },

  updateEmployersContactUs: (context, payload) => {
    return API.updateEmployersContactUs(payload);
  },

  updateCandidateStatus: (context, payload) => {
    return API.updateCandidateStatus(payload);
  },

  uploadArticleFile: (context, payload) => {
    return API.uploadArticleFile(payload);
  },

  recommendTalent: (context, payload) => {
    return API.recommendTalent(payload);
  },

  uploadEmployerPhotos: (context, payload) => {
    return API.uploadEmployerPhotos(payload);
  },

  createEmployer: (context, payload) => {
    return API.createEmployer(payload);
  },

  updateEmployer: (context, payload) => {
    return API.updateEmployer(payload);
  },

  updateEmployerStatus: (context, payload) => {
    return API.updateEmployerStatus(payload);
  },

  fetchEmployersFaqs: (context, payload) => {
    return API.fetchEmployersFaqs(payload);
  },

  fetchEmployersFaq: (context, payload) => {
    return API.fetchEmployersFaq(payload);
  },

  createEmployersFaq: (context, payload) => {
    return API.createEmployersFaq(payload);
  },

  updateEmployersFaq: (context, payload) => {
    return API.updateEmployersFaq(payload);
  },

  deleteEmployersFaq: (context, payload) => {
    return API.deleteEmployersFaq(payload);
  },

  fetchCandidatesFaqs: (context, payload) => {
    return API.fetchCandidatesFaqs(payload);
  },

  fetchCandidatesFaq: (context, payload) => {
    return API.fetchCandidatesFaq(payload);
  },

  createCandidatesFaq: (context, payload) => {
    return API.createCandidatesFaq(payload);
  },

  deleteCandidatesFaq: (context, payload) => {
    return API.deleteCandidatesFaq(payload);
  },

  updateCandidatesFaq: (context, payload) => {
    return API.updateCandidatesFaq(payload);
  },

  fetchJobApplicationsByUserId: (context, payload) => {
    return API.fetchJobApplicationsByUserId(payload);
  },

  fetchCompanies: (context, payload) => {
    return API.fetchCompanies();
  },

  fetchJobAdvertisements: (context, payload) => {
    return API.fetchJobAdvertisements();
  },

  fetchJobAdvertisementsByCompanyId: (context, payload) => {
    return API.fetchJobAdvertisementsByCompanyId(payload);
  },

  updateCompanyCredit: (context, payload) => {
    return API.updateCompanyCredit(payload);
  },

  fetchSpecializationList: (context, payload) => {
    return API.fetchSpecializationList();
  },

  updateState: (context, payload) =>
    context.commit("updateState", {
      key: payload.key,
      value: payload.value,
    }),

  updateStateObject: (context, payload) =>
    context.commit("updateStateObject", {
      key: payload.key,
      value: payload.value,
    }),
};
